import { createSystem, defaultConfig } from '@chakra-ui/react';

export const system = createSystem(defaultConfig, {
  theme: {
    tokens: {
      colors: {
        blue: {
          DEFAULT: { value: '#4185DE' },
          100: { value: '#D6E5F9' },
          200: { value: '#AFCBF3' },
          300: { value: '#89B1ED' },
          400: { value: '#6297E7' },
          500: { value: '#4185DE' },
          600: { value: '#3169B2' },
          700: { value: '#234E86' },
          800: { value: '#15335A' },
          900: { value: '#08182F' },
        },
        orange: {
          DEFAULT: { value: '#FA8939' },
          100: { value: '#FFEBD9' },
          200: { value: '#FFD0A8' },
          300: { value: '#FFB478' },
          400: { value: '#FF9950' },
          500: { value: '#FA8939' },
          600: { value: '#D36D29' },
          700: { value: '#AD551E' },
          800: { value: '#873F15' },
          900: { value: '#612B0D' },
        },
        primary: {
          blue: { value: '#4185DE' },
        },
        accent: {
          orange: { value: '#FA8939' },
          green: { value: '#3ED598' },
          red: { value: '#FF647C' },
          softBlue: { value: '#5C7CFA' },
        },
        neutral: {
          background: { value: '#F4F5F7' },
          surface: { value: '#FFFFFF' },
          border: { value: '#E5E7EB' },
          textPrimary: { value: '#7B7B93' },
          textSecondary: { value: '#7B7B93' },
          status: {
            green: { value: '#3ED598' },
            greenBg: { value: 'rgba(62, 213, 152, 0.1)' },
            orange: { value: '#FA8939' },
            orangeBg: { value: 'rgba(250, 137, 57, 0.1)' },
            red: { value: '#FF647C' },
            redBg: { value: 'rgba(255, 100, 124, 0.1)' },
          },
        },
      },
      fonts: {
        body: { value: 'Inter, sans-serif' },
        heading: { value: 'Inter, sans-serif' },
      },
      fontSizes: {
        h1: { value: '28px' },
        h2: { value: '24px' },
        h3: { value: '20px' },
        bodyLg: { value: '18px' },
        bodyMd: { value: '16px' },
        bodySm: { value: '14px' },
      },
      fontWeights: {
        regular: { value: '400' },
        bold: { value: '700' },
      },
      lineHeights: {
        h1: { value: '1.2' },
        h2: { value: '1.3' },
        h3: { value: '1.4' },
        bodyLg: { value: '1.6' },
        bodyMd: { value: '1.5' },
        bodySm: { value: '1.5' },
      },
    },
    semanticTokens: {
      colors: {
        primary: {
          solid: { value: '{colors.primary.blue}' },
          contrast: { value: 'white' },
          fg: { value: 'white' },
          muted: { value: '{colors.primary.blue}' },
          subtle: { value: '{colors.primary.blue}' },
          emphasized: { value: '{colors.primary.blue}' },
          focusRing: { value: '{colors.primary.blue}' },
        },
      },
    },
  },
});

export default system;
